import { Button } from '@ksyos/design-system';
import { translateKey } from '../../translate';

export interface IProfileCancelButtonProps {
    automation?: string;
    disabled: boolean;
    onCancel: () => Promise<void>;
}

export function CancelButton(props: IProfileCancelButtonProps) {
    return (
        <>
            <Button
                className={props.automation ? `automation-${props.automation}` : ''}
                isDisabled={props.disabled}
                onClick={async () => await props.onCancel()}
                type="button"
                variant="outline"
            >
                {translateKey('common.cancel')}
            </Button>
        </>
    );
}
